import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AuthorizationPageGate } from "@/features/admin/authorization/_components/authorization-page-gate";
import { RoleDetail } from "@/features/admin/authorization/detail";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  tab: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/admin/authorization/$roleKey")({
  validateSearch: searchSchema,
  component: RoleDetailRoute,
});

function RoleDetailRoute() {
  const { roleKey } = Route.useParams();
  return (
    <AuthorizationPageGate>
      <RoleDetail roleKey={roleKey} />
    </AuthorizationPageGate>
  );
}
